import { prompt, type PromptDefinition } from './models';

export const HVAC_TECHNICIAN_PROMPTS = [
    prompt(
        'Keep it running',
        'What HVAC servicing is due for this building?',
        'Which buildings have HVAC servicing due next?'
    ),
    prompt(
        'Keep it running',
        'What HVAC faults and repairs are recorded for this building?',
        'Which buildings have recurring HVAC faults after recorded repairs?'
    ),
    prompt(
        'Keep it running',
        'Where are the HVAC manuals and equipment schedules for this building?',
        'Which buildings lack HVAC manuals or equipment schedules needed for servicing?'
    ),
    prompt(
        'Keep it running',
        'Find HVAC service instructions for this building covering…',
        'Find HVAC service instructions across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        "What filter, refrigerant or component work is recorded for this building's HVAC?",
        'Compare recorded HVAC filter, refrigerant and component work across my buildings.'
    ),
    prompt(
        'Manage risk',
        'What isolation and access requirements apply to HVAC work in this building?',
        'Which buildings have missing isolation or access details for HVAC work?'
    ),
    prompt(
        'Improve performance',
        "What temperature, airflow or balancing issues are flagged in this building's reports?",
        'Which buildings have HVAC temperature, airflow or balancing issues to investigate?'
    ),
    prompt(
        'Keep it running',
        'Find HVAC fault reports for this building involving…',
        'Find HVAC fault reports across my buildings involving…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        "What commissioning or balancing records are available for this building's HVAC?",
        'Which buildings lack HVAC commissioning or balancing records?'
    ),
    prompt(
        'Keep it running',
        "What recommendations from this building's HVAC inspections remain unresolved?",
        'Which buildings have unresolved HVAC inspection recommendations?'
    ),
    prompt(
        'Keep it running',
        'Which HVAC service records for this building need readings or completion evidence?',
        'Which buildings have incomplete HVAC readings or service completion evidence?'
    ),
    prompt(
        'Keep it running',
        'Trace HVAC service history for equipment in this building identified as…',
        'Compare HVAC service histories across my buildings for equipment identified as…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
